
import UIHelper from "general/helpers/UIHelper";
import DriverReconciliationDetailView from "../../components/DriverReconciliationDetailView";
import useRouter from "hooks/useRouter";
import { useSelector } from "react-redux";

DriverReconciliationDetailScreen.propTypes = {};

function DriverReconciliationDetailScreen(props) {
    const router = useRouter();
    const { user } = useSelector(state => state.auth);
    const adminRole = user?.role === 'ADMIN' || user?.role === 'OPERATOR';

    return (
        <div>
            {/* breadcrumb */}
            <div>
                {adminRole
                    ? UIHelper.buildBreadcrumb([
                        {
                            title: 'Báo cáo đối soát DNVT',
                            onPress: () => {
                                router.navigate(-2);
                            },
                        },
                        {
                            title: 'Đối soát tài xế doanh nghiệp',
                            onPress: () => {
                                router.navigate(-1);
                            },
                        },
                        { title: 'Chi tiết đối soát' },
                    ])
                    : UIHelper.buildBreadcrumb([
                        {
                            title: 'Đối soát tài xế doanh nghiệp',
                            onPress: () => {
                                router.navigate(-1);
                            },
                        },
                        { title: 'Chi tiết đối soát' },
                    ])}
            </div>
            <div className="container-fluid px-4 my-4">
                <DriverReconciliationDetailView />
            </div>
        </div>
    );
}

export default DriverReconciliationDetailScreen;
